import { render, staticRenderFns } from "./DataTablePageSizeSelect.vue?vue&type=template&id=344ea5fc&scoped=true&"
import script from "./DataTablePageSizeSelect.vue?vue&type=script&lang=js&"
export * from "./DataTablePageSizeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344ea5fc",
  null
  
)

export default component.exports